import React, { createContext, useEffect, useState } from 'react';
import ComponentIdentifier from '../CommonComponent/ComponentHeader/ComponentIdentifier';
import { Card } from 'react-bootstrap';
import PromisedHistoryForm from './SubComponent/PromisedHistoryForm';
import PromisedHistoryTable from './SubComponent/PromisedHistorytable';
import PromisedHistorytable from './SubComponent/PromisedHistorytable';
import CommonModal from '../CommonComponent/CommonModal/CommonModal';
import PromisedToDonation from './SubComponent/PromisedToDonation';
import { ToastContainer } from 'react-toastify';
import { promisedHistoryAction } from '../../Redux/Action/AgentAction';
import { useDispatch } from 'react-redux';
import PromiseEditForm from './SubComponent/PromiseEditForm';
import PromiseDeleteForm from './SubComponent/PromiseDeleteForm';
import Auth from '../../Utilities/Auth';

export const PromisedDonerHistoryContext = createContext()
function PromisedDonerComponent(props) {
    const dispatch = useDispatch()

    //State
    const [promisedDonerHistory, setPromisedDonerHistory] = useState([])
    const [promisedToCollectionModelShow, setPromisedToCollectionModelShow] = useState(false)
    const [promisedToCollectionSingle, setPromisedToCollectionSingle] = useState({})
    const [promisedReload, setPromisedReload] = useState(false)
    const [promiseEditModal, setPromiseEditModal] = useState(false)
    const [promiseDeletetModal, setPromiseDeleteModal] = useState(false)
    const [filteredPromisedCollectionHistory, setFilteredPromisedCollectionHistory] = useState([])

    const user_detail = JSON.parse(Auth.header().userdetail)





    return (
        <>
            <PromisedDonerHistoryContext.Provider value={{
                promisedDonerHistory,
                setPromisedDonerHistory,
                promisedToCollectionModelShow,
                setPromisedToCollectionModelShow,
                promisedToCollectionSingle,
                setPromisedToCollectionSingle,
                promisedReload,
                setPromisedReload,
                setPromiseEditModal,
                setPromiseDeleteModal,
                filteredPromisedCollectionHistory,
                setFilteredPromisedCollectionHistory
            }}>
                <Card>
                    <Card.Header className="d-flex align-items-center justify-content-between">
                        <ComponentIdentifier link_name={"Promised History"} component_name={""} />
                    </Card.Header>
                    <Card.Body>
                        <PromisedHistoryForm />
                        <PromisedHistorytable />


                    </Card.Body>
                </Card>
                {/*collection modal show*/}
                <CommonModal
                    show={promisedToCollectionModelShow}
                    setShow={setPromisedToCollectionModelShow}
                    title={"Promised to Donation"}
                    size="md"
                >
                    <PromisedToDonation />

                </CommonModal>

                {/* edit promise */}
                <CommonModal
                    show={promiseEditModal}
                    setShow={setPromiseEditModal}
                    title={"Promise Edit"}
                    size="md"
                >
                    <PromiseEditForm default_data={promisedToCollectionSingle} />

                </CommonModal>

                <CommonModal
                    show={promiseDeletetModal}
                    setShow={setPromiseDeleteModal}
                    title={"Promise delete"}
                    size="md"
                >
                    <PromiseDeleteForm />

                </CommonModal>
                <ToastContainer />
            </PromisedDonerHistoryContext.Provider>
        </>
    );
}

export default PromisedDonerComponent;